import { DialogContent, DialogTitle } from "@mui/material"
import { DataInputDialog } from "lib/@dialogs/data-input-dialog"
import { CreateRuleSetFormBody } from "./create-rule-set-form-body"

export function CreateRuleSetDialog() {
    return (
        <DataInputDialog
            initialValue={{
                name: "",
                description: "",
                regime: null,
                assetRegister: null,
                includeByDefault: true,
            }}
            okCaption="Create"
            okDisabled={isInvalid}
        >
            <DialogTitle sx={{ pb: 3 }}>Create Rule Set</DialogTitle>
            <DialogContent sx={{ pb: 0.5 }}>
                <CreateRuleSetFormBody />
            </DialogContent>
        </DataInputDialog>
    )
}

function isInvalid(v) {
    if (!v?.name?.trim()) return true
    return false
}
